/* eslint-disable */

import { VueEditor } from "vue2-editor";
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'add-quiz',
  components: {
    VueEditor
  },
  props: [],
  data() {
    return {
      quizData: {
        courseId: '',
        name: '',
        category: '',
        instruction: '',
        quiz_number: '',
        time_limit:90,
      },
      coursesCategory: {},
      submitted:false,
      QuizList:null,
      courseDetais:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      instruction:''
    }
  },
  computed: {
    ...mapGetters([
      'getsectionbycourseIDState'
    ]),
    getCourseDetails() {
      this.courseDetais = this.$store.getters.getsectionbycourseIDState.data
      return this.courseDetais
    },
    SetIntialValue() {
      if (this.courseDetais != undefined) {
        this.quizData.category = this.courseDetais.category[0].id
      }
    }
  },
  mounted() {
    this.quizData.courseId = this.$route.params.courseId;
    this.getCourseDetails
    this.SetIntialValue
  },
  methods: {
    validateCreateQuizBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.quizData.name,
            instruction: this.quizData.instruction,
            category: this.quizData.category,
            quiz_number:this.quizData.quiz_number,
            time_limit:this.quizData.time_limit,
            course:this.$route.params.courseId
          }
          this.$store.dispatch('createQuizFun', data)
          .then((res) => {
            this.quizData.name = '',
            this.quizData.instruction = '',
            this.quizData.category = '',
            this.quizData.time_limit = '',
            toast.success(res.data.msg);
            this.$validator.reset();
            this.$router.push('/courses/' + this.quizData.courseId + '/quiz/' + res.data.data.id + '/question-answer/list')
            })
            .catch((err) => {})
          return
        }
      });
    },
  },
  beforeMount() {
    this.getCourseDetails
  },
  watch: {
    getCourseDetails() {
      return this.$store.getters.getsectionbycourseIDState.data
    },
    SetIntialValue() {
      if (this.courseDetais != undefined) {
        this.quizData.category = this.courseDetais.category[0].id
      }
    }
  },
}